import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { config } from 'config';
import { LoaderService } from './loader.service';
import { appSetting } from 'config/appSettings';
import { AuthService } from './auth.service';
import { environment } from 'environments/environment';
@Injectable()
export class AppHelperService {

    classId:string;//store class id of the book from route
    spaceId:string;//store spaceId from studentbook
    bundleCode:string;//store bundlecode studentbook
    constructor(
        private loaderService: LoaderService,
        private authService: AuthService,
        public router: Router,
        ) { }

    isAbsoluteUrl(url) {
        let pat = /(^https?:\/\/)|(^\/\/)/i;
        return pat.test(url);
    }

    // This method navigates the user to the dashboard. Pass the correct 'urlArray' based on the user's role. 
    // If the role or tab information is unavailable, pass an empty array. The method will handle the navigation accordingly.
    navigateToDashboardApp(urlArray) {
        this.loaderService.showOverlayLoader();
        let userData = this.authService.getUserData();
        let userRole = userData.role == 'student' ? 'student' : 'teacher';

        // Hiding foc loader before navigating
        this.loaderService.hideLoader();
        
        if (environment.isDesktopApp) {
            let path;
            if (userRole == 'teacher') {
                path = '/teacher-dashboard';
                if (!this.classId) {
                    path = '/teacher-dashboard/' + this.spaceId + '/bundle/' + this.bundleCode + '/view';
                }
            } else if (userRole == 'student') {
                path = '/learner-dashboard';
            }


            // clearing cache
            DLS_IPCCallers.CLEAR_CACHE();

            if(path == this.router.url){
                this.loaderService.hideLoader();
            }else{
                this.router.navigate([path]);
            }
        } else if (this.classId && userRole != 'student') {
            this.navigateToClassApp([]);
        } else if(userRole == "teacher" && this.spaceId && this.bundleCode){
            window.location.href = config.dashboardAppDomain + ['teacher', this.spaceId, 'bundle', this.bundleCode, "view"].join('/') ;
        } else {
            urlArray = urlArray.length > 0 ? urlArray : this._getUrlArrayBasedOnRole();  
            window.location.href = config.dashboardAppDomain + urlArray.join('/');
        }
    }

        
    // Updates the URL based on the user's role and last visited tab.
    // If the user is a teacher, it retrieves the last visited tab from local storage.
    // If the last visited tab is available, it sets the tab to that value.
    // Returns an array with the user's role and the selected tab.
    _getUrlArrayBasedOnRole() {
        const userData = this.authService.getUserData();
        let role = userData.role;
        // Default tab
        let tab = 'dashboard';
    
        if (role === 'teacher') {
            // Generate a key for local storage using the user's external ID (extUserId)
            const key = appSetting.localStorage.dashboard(userData.extUserId);
    
            // Retrieve the last visited tab data from localStorage using the key
            const lastVisitedTab = localStorage.getItem(key);
    
            // If last visited tab data exists and contains a valid selectedTab, update the tab to selectedTab
            if (lastVisitedTab) {
                const { selectedTab } = JSON.parse(lastVisitedTab);
                if (selectedTab) {
                    tab = selectedTab;
                }
            }
        }
        else if(role == 'student'){
            role = 'learner';
        }

        return [role, tab];
    }

    // navigate to desktop app login page
    navigateToLoginPage(isOnline){
        if(isOnline){
            this.router.navigate(['/launch-page']);
        }
        else{
            this.router.navigate(['/offline-login-error-page']);
        }
    }

    navigateToClassApp(urlArray, options?){
        let userData = this.authService.getUserData();
        let userRole = userData.role == 'student' ? 'student' : 'teacher';

        if(userRole == "teacher"){
            window.location.href = config.onBoardingAppDomain + ['class', 'teacher', this.spaceId, 'class', this.classId, "view", "materials"].join('/') ;
        }
        else if(userRole == "student"){
            window.location.href = config.onBoardingAppDomain + ['class', 'learner', this.spaceId, 'class', this.classId].join('/');
        }
    }

    navigateFromAssignmentModal(spaceId, classId, options?) {
        let route = config.onBoardingAppDomain + ['class', 'teacher', spaceId, 'class', classId, 'create', 'assignments'].join('/');
        if(options?.isEdgeCase) {
            switch (options.edgeCaseType) {
                case 1:
                    route = config.onBoardingAppDomain + ['dashboard', 'teacher', 'create-class'].join('/');
                    break;
                case 2:
                    route = config.onBoardingAppDomain + ['class', 'teacher', spaceId, 'class', classId, 'add-materials'].join('/');
                    break;
                case 3:
                    route = config.onBoardingAppDomain + ['dashboard', 'teacher', 'dashboard'].join('/');
                    break;
            }
        }

        route = route + '?' + Object.keys(options.queryParams).map(key => `${key}=${options.queryParams[key]}`).join('&'); 
        window.location.href = route;
    }

    navigateToOnboardingApp(urlArray, options?) {
        this.loaderService.showOverlayLoader();
        if (options && options.queryParams && Object.keys(options.queryParams).length > 0) {
            window.location.href = config.onBoardingAppDomain + urlArray.join('/') + '?' + Object.keys(options.queryParams).map(key => `${key}=${options.queryParams[key]}`).join('&');
        } else {
            window.location.href = config.onBoardingAppDomain + urlArray.join('/');
        }
    }

    navigateToAdminApp(urlArray, options?) {
        this.loaderService.showOverlayLoader();
        if (options && options.queryParams && Object.keys(options.queryParams).length > 0) {
            window.location.href = config.adminAppDomain + urlArray.join('/') + '?' + Object.keys(options.queryParams).map(key => `${key}=${options.queryParams[key]}`).join('&');
        } else {
            window.location.href = config.adminAppDomain + urlArray.join('/');
        }
    }
    
    async showLoaderAndNavigateToDashboard(classId, spaceId, bundleCode) {
        let userData = this.authService.getUserData();
        let userRole = userData.role == 'student' ? 'student' : 'teacher';

        this.loaderService.showOverlayLoader();

        this.classId = classId;
        this.spaceId = spaceId;
        this.bundleCode = bundleCode;
        // Get the value from localstorage the current toggle value for admin is "admin/teacher"
        let key = appSetting.localStorage.adminSelectedView + userData.extUserId;
        let adminSelectedView = localStorage.getItem(key);

        // if user id admin as toggled to teacher navigate to teacher Dashboard
        // else the '/' route will take to correct location
        if (userRole == 'admin') {
            if (adminSelectedView === "teacher") {
                this.navigateToDashboardApp(['teacher', 'dashboard']);
            } else {
                this.navigateToAdminApp(['admin', 'dashboard']);
            }
        } else {
            this.navigateToDashboardApp([]);
        }
    }

    /*Set a particular field of JSON value in local storage
      @params : 
            key : localstorage key
            field: field in JSON value which needs to be updated in format a.b.c 
                   for object {a : {b : {c : 6}}}, to update c send a.b.c in field param
            data : value to be updated
    */
    setFieldInValueObj(key, field, data) {
        let value = JSON.parse(localStorage.getItem(key)) || {};
        let fieldArr = field.split('.');
        return fieldArr.reduce((nestedObj, curr, index) => {
            if (index == fieldArr.length - 1) {
                nestedObj[curr] = data;
                localStorage.setItem(key, JSON.stringify(value))
            } else {
                nestedObj[curr] = nestedObj[curr] || {}
                return nestedObj[curr];
            }
        }, value)
    }

    /*Get a particular field of JSON value in local storage
      @params : 
            key : localstorage key
            field: field in JSON value in format a.b.c
                   for object {a : {b : {c : 6}}}, to get c send a.b.c in field param
    */
    getFieldFromValueObj(key, field) {
        return field.split(".").reduce((nestedObj, curr) => nestedObj && nestedObj[curr] ? nestedObj[curr] : undefined,
            JSON.parse(localStorage.getItem(key)));
    }

    /*
        * This function is used for getting required query params from existing query params in url
    */
    getRequiredQueryParams(parmsObject, requiredFields) {
        let mappedQuery = {};
        requiredFields.forEach(param=>{
            if(parmsObject.hasOwnProperty(param)) {
                mappedQuery[param] = parmsObject[param];
            }
        })
        return mappedQuery;
    }

    getCookie(name) {
        let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }
    
    hideLoaderAndNavigateToDashboardApp(classId, spaceId, bundleCode) {
        this.loaderService.hideLoader();
        let userData = this.authService.getUserData();
        if (environment.isDesktopApp) {
            let path;
            if (userData.role == 'teacher') {
                path = '/teacher-dashboard';
            } else if (userData.role == 'student') {
                path = '/learner-dashboard';
            }
            if (!classId) {
                if (userData.role == "teacher") {
                    path = '/teacher-dashboard/'+ spaceId + '/bundle/' + bundleCode + '/view';
                }
            }
            this.router.navigate([path]);
        }
    }
}
